import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { getUserInfo } from '../../Config/Auth';

import Sidebar from '../Components/Sidebar/Sidebar';
import Navbar from '../Components/Navbar/Navbar';

import Profile from '../Components/Profile/Profile';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Jobs from '../Pages/Jobs/Jobs';
import CCInvoices from '../Pages/CCInvoices/CCInvoices';
import ConstructionCompany from '../Pages/ConstructionCompany/ConstructionCompany';
import SiteUsers from '../Pages/SiteUsers/SiteUsers';
import Notifications from '../Pages/Notifications/Notifications';
import Settings from '../Pages/Settings/Settings';
import TruckCompany from '../Pages/TruckCompany/TruckCompany';
import TruckCompanyTrucks from '../Pages/TruckCompanyTrucks/TruckCompanyTrucks';
import Reports from '../Pages/Reports/Reports';
import TCInvoices from '../Pages/TCInvoices/TCInvoices';
import WorkInProgress from "../../../../Pages/WorkInProgress/WorkInProgress"

import ProtectedRoute from './ProtectedRoute';


const HSRoutes = () => {
  const user = getUserInfo();

  return (
    <div className="app">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        <Routes>
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute requiredPermission={{ section: 'dashboard', keys: ['dashboard_view']}}><Dashboard /></ProtectedRoute>} />
          <Route path="/c-companies" element={<ProtectedRoute requiredPermission={{ section: 'Construction Companies', keys:["cc_view", "cc_manage"]}}><ConstructionCompany /></ProtectedRoute>} />
          <Route path="/t-companies" element={<ProtectedRoute requiredPermission={{ section: 'Truck Companies', keys: ["tc_view", "tc_manage"] }}><TruckCompany /></ProtectedRoute>} />
          <Route path="/t-companies/:companyId/trucks" element={<ProtectedRoute requiredPermission={{ section: 'Truck Companies', keys: ["tc_view", "tc_manage"] }}><TruckCompanyTrucks /></ProtectedRoute>} />
          <Route path="/jobs" element={<ProtectedRoute requiredPermission={{ section: 'Jobs', keys:['jobs_view'] }}><Jobs /></ProtectedRoute>} />
          <Route path="/cc-invoices" element={<ProtectedRoute requiredPermission={{ section: 'CC Invoices', keys: ["ccinvoices_view"] }}><CCInvoices /></ProtectedRoute>} />
          <Route path="/tc-invoices" element={<ProtectedRoute requiredPermission={{ section: 'TC Invoices', keys:["tcinvoices_view", "tcinvoices_update"] }}><TCInvoices /></ProtectedRoute>} />
          <Route path="/siteusers" element={<ProtectedRoute requiredPermission={{ section: 'Site Users', keys: ['siteusers_view', 'siteusers_edit'] }}><SiteUsers /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute requiredPermission={{ section: 'Notifications', keys: ['notifications_view','notifications_manage'] }}><Notifications /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute requiredPermission={{ section: 'Reports', keys: ["job_summary_view", "invoice_summary_view"] }}><Reports /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute requiredPermission={{ section: 'Settings', keys: ['settings_view', 'settings_edit_roles', 'settings_edit_settings'] }}><Settings /></ProtectedRoute>} />
        </Routes>
      </div>
    </div>
  );
};

export default HSRoutes;
